import { MessageType } from '@tencent/dz-models';
import Component from './Form';
import { withType } from '../../../hoc/withType';
// // 新医疗表单
var BlockMedicalForm = withType(Component);
BlockMedicalForm.msgType = MessageType.MedicaleForm;
// 自助咨询表单
var BlockSelfConsultForm = withType(Component);
BlockSelfConsultForm.msgType = 14;
// 离线表单
var BlockOfflineForm = withType(Component);
BlockOfflineForm.msgType = MessageType.OfflineForm;
// 网页自助咨询表单
var BlockFormOrder = withType(Component);
BlockFormOrder.msgType = MessageType.FormOrder;
export { BlockSelfConsultForm, BlockMedicalForm, BlockOfflineForm, BlockFormOrder };
